import { withInstall } from '@lit-element/utils'
import Tree from './src/tree.vue'

import type { SFCWithInstall } from '@lit-element/utils'

export const LtTree: SFCWithInstall<typeof Tree> = withInstall(Tree)

export default LtTree

export type { TreeInstance } from './src/instance'
